import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import { user, notes } from '@/helpers/APIconnection';
import { desktopAppData } from '@/helpers/desktop-controller';
export default {
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
    AppSidebarArguments() {
      const items = this.appSidebarArguments.items?.filter(r => !r.hidden?.() && !(r.route && this.$appConfig.hidden_routes?.includes(r.route.path)));
      return {
        ...this.appSidebarArguments,
        items: items.reduce((acc, obj, index, array) => {
          if (obj.type === 'separator' && (!acc[0] || array[index + 1]?.type === 'separator' || index === array.length - 1)) return acc;
          acc.push(obj);
          return acc;
        }, [])
      };
    },
    CustomSidebarArguments() {
      if (this.$state.customSidebarArguments?.animation === 'cascade') {
        this.$nextTick(() => {
          const items = this.$refs['sidebar-menu-container']?.children;
          if (!items) {
            return;
          }
          items.forEach((item, index) => {
            item.classList.add('menu-item-animation', 'opacity-0');
            item.style['animation-delay'] = 50 * index + 'ms';
          });
        });
      }
      return this.$state.customSidebarArguments;
    },
    Items() {
      const items = this.CustomSidebarArguments ? this.CustomSidebarArguments.items : this.AppSidebarArguments.items;
      const normalizedItems = [];
      items.forEach(i => {
        if (i.type === 'separator') {
          if (normalizedItems[normalizedItems.length - 1]?.type !== 'separator') normalizedItems.push(i);
          return;
        }
        if (i.hidden && i.hidden()) return;
        if (this.$appConfig?.hidden_routes && i.route && this.$appConfig.hidden_routes.includes(i.route.path)) return;
        normalizedItems.push(i);
      });
      return normalizedItems;
    }
  },
  data: function () {
    return {
      user,
      desktopVersion: undefined,
      appSidebarArguments: {
        drawer: true,
        items: [{
          type: 'button',
          label: 'app.home.name',
          icon: 'icon-home',
          route: this.$router.resolve({
            name: 'Home'
          }),
          onclick: () => {
            this.$router.push({
              name: 'Home'
            });
          },
          isActive: () => {
            return this.$route.name === 'Home';
          }
        }, {
          type: 'separator'
        },
        // {
        // 	type: 'button',
        // 	label: 'app.workspaces.name',
        // 	icon: 'icon-workspace',
        // 	onclick: () => { this.$router.push({ name: 'Workspace-Assessor' }) },
        // 	isActive: () => { return this.$route.name === 'Workspace-Assessor' },
        // 	hidden: () => !this.$router.resolve({ name: 'Workspace-Assessor' }).meta.allowed?.()
        // },
        {
          type: 'button',
          label: 'app.consultant.name',
          icon: 'icon-flow',
          route: this.$router.resolve({
            name: 'FlowsPanel'
          }),
          onclick: () => {
            this.$router.push({
              name: 'FlowsPanel'
            });
          },
          isActive: () => {
            return this.$route.name === 'FlowsPanel';
          }
        }, {
          type: 'button',
          label: 'Mis recursos',
          icon: 'icon-workspace text-xl',
          route: this.$router.resolve({
            name: 'WorkEnvironmentSetup'
          }),
          onclick: () => {
            this.$router.push({
              name: 'WorkEnvironmentSetup'
            });
          },
          isActive: () => {
            return this.$route.name === 'WorkEnvironmentSetup';
          },
          hidden: () => !this.$router.resolve({
            name: 'WorkEnvironmentSetup'
          }).meta.allowed?.()
        }, {
          type: 'button',
          label: 'app.altasbajas.name',
          image: require('@/assets/icons/altasbajas.svg'),
          route: this.$router.resolve({
            name: 'AltasBajasDashboard'
          }),
          onclick: () => {
            this.$router.push({
              name: 'AltasBajasDashboard'
            });
          },
          isActive: () => {
            return this.$route.name === 'AltasBajasDashboard';
          }
        }, {
          type: 'button',
          label: 'FIE',
          icon: 'icon-fie',
          route: this.$router.resolve({
            name: 'FIE'
          }),
          onclick: () => {
            this.$router.push({
              name: 'FIE'
            });
          },
          isActive: () => {
            return this.$route.name === 'FIE';
          }
        }, {
          type: 'button',
          label: 'app.notifications.name',
          icon: 'icon-bell',
          route: this.$router.resolve({
            name: 'NotificationsDashboard'
          }),
          onclick: () => {
            this.$router.push({
              name: 'NotificationsDashboard'
            });
          },
          isActive: () => {
            return this.$route.name === 'NotificationsDashboard';
          }
          // hidden: () => !this.$router.resolve({ name: 'NotificationsDashboard' }).meta.allowed?.()
        }, {
          type: 'button',
          label: 'app.roboteka.name',
          icon: 'icon-roboteka',
          route: this.$router.resolve({
            name: 'Roboteka'
          }),
          onclick: () => {
            this.$router.push({
              name: 'Roboteka'
            });
          },
          isActive: () => {
            return this.$route.name === 'Roboteka';
          }
        }, {
          type: 'button',
          label: 'app.recorder.name',
          icon: 'icon-recorder',
          route: this.$router.resolve({
            name: 'MacroRecorder'
          }),
          onclick: () => {
            this.$router.push({
              name: 'MacroRecorder'
            });
          },
          isActive: () => {
            return this.$route.name === 'MacroRecorder';
          }
        }, {
          type: 'button',
          label: 'app.smartbuilder.name',
          icon: 'icon-smart-builder',
          route: this.$router.resolve({
            name: 'SmartBuilder'
          }),
          onclick: () => {
            this.$router.push({
              name: 'SmartBuilder'
            });
          },
          isActive: () => {
            return this.$route.name === 'SmartBuilder';
          },
          hidden: () => !this.$router.resolve({
            name: 'SmartBuilder'
          }).meta.allowed?.()
        }, {
          type: 'separator'
        }, {
          type: 'button',
          label: 'Gestor',
          image: require('@/assets/icons/afianza.svg'),
          route: this.$router.resolve({
            name: 'DocumentManager'
          }),
          onclick: () => {
            this.$router.push({
              name: 'DocumentManager'
            });
          },
          isActive: () => {
            return this.$route.name === 'DocumentManager';
          },
          hidden: () => !this.$router.resolve({
            name: 'DocumentManager'
          }).meta.allowed?.()
        }, {
          type: 'separator',
          hidden: () => !this.$router.resolve({
            name: 'DocumentManager'
          }).meta.allowed?.()
        }, {
          type: 'button',
          label: 'Frumecar',
          image: require('@/assets/icons/frumecar.svg'),
          route: this.$router.resolve({
            name: 'Frumecar'
          }),
          onclick: () => {
            this.$router.push({
              name: 'Frumecar'
            });
          },
          isActive: () => {
            return this.$route.name === 'Frumecar';
          },
          hidden: () => !this.$router.resolve({
            name: 'Frumecar'
          }).meta.allowed?.()
        }, {
          type: 'separator',
          hidden: () => !this.$router.resolve({
            name: 'Frumecar'
          }).meta.allowed?.()
        }, {
          type: 'button',
          label: 'app.help.name',
          icon: 'icon-help',
          route: this.$router.resolve({
            name: 'Help'
          }),
          onclick: () => {
            this.$router.push({
              name: 'Help'
            });
          },
          isActive: () => {
            return this.$route.name === 'Help';
          }
        }
        // {
        // 	type: 'button',
        // 	label: 'Tutoriales',
        // 	icon: 'icon-form',
        // 	onclick: () => { this.$router.push({ name: 'OnBoarding' }) },
        // 	isActive: () => { return this.$route.name === 'OnBoarding' }
        // },
        ]
      }
    };
  },
  async created() {
    if (desktopAppData) this.desktopVersion = await desktopAppData.DesktopVersion;
  },
  methods: {
    IsMenuItemSelected: function (path) {
      this.$route.href === path;
    },
    GetUpdateNotes: async function () {
      notes.getActive(true);
    }
  }
};